import React from "react";
import { Link } from "react-router-dom";
import { AiOutlinePhone, AiOutlineMail } from "react-icons/ai";
import { CiLocationOn } from "react-icons/ci";
import { FiArrowUp } from "react-icons/fi";

export const LandingFooter: React.FC = () => {
  const currentYear = new Date().getFullYear();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer className="bg-slate-950 text-white pt-16 pb-12 border-t border-slate-900 relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-12">

        {/* Main Columns Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-10">

          {/* Brand Info */}
          <div className="lg:col-span-5 space-y-6">
            <Link to="/landingpage" className="flex items-center gap-3 group">
              <img
                src="/15.svg"
                alt="Pendulum Digital Logo"
                className="h-12 w-auto object-contain"
                onError={(e) => {
                  (e.target as HTMLElement).style.display = "none";
                }}
              />
              <div className="flex flex-col">
                <span className="font-black text-white text-lg tracking-tight">
                  PENDULUM DIGITAL
                </span>
                <span className="text-[10px] font-black uppercase tracking-widest text-blue-400">
                  School & Childcare Ecosystem
                </span>
              </div>
            </Link>

            <p className="text-xs sm:text-sm text-slate-400 leading-relaxed max-w-md font-medium">
              Empowering African educators, students, and parents with real-time technology solutions that streamline school operations, improve academic outcomes, and ensure safe pickup governance.
            </p>

            {/* Contact Details Cards */}
            <div className="space-y-3 pt-2 text-xs font-bold text-slate-300">
              <div className="flex items-center gap-3 bg-slate-900/80 p-3 rounded-2xl border border-slate-800/80 w-fit">
                <AiOutlinePhone className="text-blue-400 text-base shrink-0" />
                <span>+234 913 782 6058</span>
              </div>

              <div className="flex items-center gap-3 bg-slate-900/80 p-3 rounded-2xl border border-slate-800/80 w-fit">
                <AiOutlineMail className="text-blue-400 text-base shrink-0" />
                <span>pendulumdigitals@gmail.com</span>
              </div>

              <div className="flex items-center gap-3 bg-slate-900/80 p-3 rounded-2xl border border-slate-800/80">
                <CiLocationOn className="text-blue-400 text-base shrink-0" />
                <span>19b Ilawe Street Ifako Gbagada Lagos</span>
              </div>
            </div>
          </div>

          {/* Quick Links Column */}
          <div className="lg:col-span-3 space-y-4">
            <h4 className="font-black text-sm text-white uppercase tracking-wider">
              Quick Navigation
            </h4>
            <ul className="space-y-2.5 text-xs font-semibold text-slate-400">
              <li>
                <a href="#about" className="hover:text-blue-400 transition-colors">
                  About Pendulum Digital
                </a>
              </li>
              <li>
                <a href="#how-it-works" className="hover:text-blue-400 transition-colors">
                  How It Works & Features
                </a>
              </li>
              <li>
                <a href="#newsletter" className="hover:text-blue-400 transition-colors">
                  Newsletter & Insights
                </a>
              </li>
              <li>
                <a href="#FAQs" className="hover:text-blue-400 transition-colors">
                  Frequently Asked Questions
                </a>
              </li>
            </ul>
          </div>

          {/* Portals & Sign In Column */}
          <div className="lg:col-span-4 space-y-4">
            <h4 className="font-black text-sm text-white uppercase tracking-wider">
              Access Portals
            </h4>
            <p className="text-xs text-slate-400 font-medium">
              Access administrative dashboards, staff result uploads, parent portals, or register a new school.
            </p>
            <div className="flex flex-wrap gap-2 pt-2">
              <Link
                to="/login"
                className="px-5 py-2.5 bg-slate-900 hover:bg-slate-800 text-white rounded-xl text-xs font-bold border border-slate-800 transition-all"
              >
                Sign In
              </Link>
              <Link
                to="/register"
                className="px-5 py-2.5 bg-blue-600 hover:bg-blue-500 text-white rounded-xl text-xs font-bold transition-all shadow-md"
              >
                Register School
              </Link>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-slate-900 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs font-medium text-slate-500">
          <p>© {currentYear} Pendulum Digital. All Rights Reserved.</p>

          <button
            type="button"
            onClick={scrollToTop}
            className="flex items-center gap-2 bg-slate-900 hover:bg-slate-800 text-slate-300 px-4 py-2 rounded-xl border border-slate-800 transition-all text-xs font-bold"
          >
            Back to Top <FiArrowUp />
          </button>
        </div>

      </div>
    </footer>
  );
};

export default LandingFooter;
